<template>
  <div class="quick-menu-link__container iw-layout-grid">
    <div class="iw-layout-grid__row quick-menu-link__row">
      <div class="iw-layout-grid__col--span-12">
        <app-link :route-to="{ name: ROUTE_NAMES.VENDOR_PICKER }" class="quick-menu-link__back-link" aria-label="Back">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
            <g fill="none" fill-rule="evenodd">
              <g stroke="currentColor" stroke-width="2">
                <g>
                  <path d="M8 0L0 7.5 8 15" transform="translate(-14 -75) translate(16 76)" />
                  <path stroke-linecap="square" d="M1.633 7.5L19.367 7.5" transform="translate(-14 -75) translate(16 76)" />
                </g>
              </g>
            </g>
          </svg>
        </app-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/utils";

export default {
  name: "QuickMenuLink",
  data: function () {
    return {
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters({
      vendorAliasPlural: "venue/getVendorAliasPlural"
    })
  }
};
</script>

<style scoped lang="scss">
.quick-menu-link {
  &__container {
    width: 100%;
  }

  &__row {
    padding-bottom: 8px;
  }

  &__back-link {
    @include app-link;
    position: static;
    padding-left: $spacer;
  }
}
</style>
